export class StoryTranslationMetaInfo {
    title: string;
    description: string;
}

export class StoryTranslationChapterModel extends StoryTranslationMetaInfo  {
    annotations?: StoryTranslationMetaInfo[];
    hotspots?: StoryTranslationMetaInfo[];
}

export class StoryTranslationModel {

    displayName: string;
    description: string;
    iso_639_1: string;
    language: string;

    chapters?: StoryTranslationChapterModel[];

    hotspots?: StoryTranslationMetaInfo[];

    objects?: {
        [key: string]: string; 
    };
}
